/**
 * Gallery sort vocabulary (D2.7, ARCFE-1046) — the `/contracts` door's stated
 * scope includes sort vocabulary alongside types and key factories.
 *
 * DELIBERATELY A STRUCTURAL UNION, NOT A MOVED ENUM. The app's
 * `TemplateCommunitySortBy` in `src/types/index.ts` is hand-authored and widely
 * imported; its members are string literals equal to their names, so the enum
 * is assignable to this union and every existing importer keeps working
 * untouched. Moving the enum itself would be the `TemplateSortBy` hazard from
 * D1.1 — a hand-authored enum relocated next to a schema sibling of a similar
 * name, where the body text is identical and only the resolved type changes.
 *
 * The union is the package's ACCEPTED INPUT; the wire encoding below is the
 * package's own and is not duplicated app-side.
 */
export type CommunityTemplateSortKey = 'MOST_POPULAR' | 'MOST_RECENT' | 'ALPHABETICAL';

/**
 * Sort key to the API's `sort_field`. Copied from the two gallery hooks, which
 * each carried an identical private copy of this map — the duplication is what
 * made it worth promoting to one definition rather than moving it twice.
 */
export const communityTemplateSortField: Record<CommunityTemplateSortKey, string> = {
  MOST_POPULAR: 'imports_count',
  MOST_RECENT: 'created_at',
  ALPHABETICAL: 'title',
};
